import AuthorizationHelper from '@auth/services/authorization.helper';
import ModulesHelper from '@core/services/modules.helper';

export const configurationPaymentTerminalsRoutes = [
  {
    path: 'terminals',
    name: 'admin-terminals',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.terminals],
      module: ModulesHelper.ACCOUNTING_MODULE_NAME,
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-terminals" */ '@payment-terminals/pages/terminals/terminals.vue'
      ),
  },
];
